import React from 'react';
import PropTypes from 'prop-types';

export const FormReset = ({ children }) => {
  return <div className="swformreset">{children}</div>;
};

FormReset.propTypes = {
  children: PropTypes.any.isRequired
};
